import CriptoJs from 'crypto-js'
import library from '../../../../utils/Library'

const adminSetUserPassword = (user, callback) => {
  const URL_SET_PASSWORD = library.getBaseAPIUrl('e_auth_set_password')
  const CLIENT_ID = String(library.getBaseAPIUrl('e_auth_client_id'))

  const passEncrypt = CriptoJs.AES.encrypt(
    user.password,
    CLIENT_ID
  ).toString()

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username: user.username,
      password: passEncrypt
    })
  }

  try {
    fetch(URL_SET_PASSWORD, requestOptions)
      .then((response) => {
        if (response.status !== 200) callback(null)
        // eslint-disable-next-line
        callback({ message: "Change password success!" });
      })
      .catch(() => callback(null))
  } catch (error) {
    callback(null)
  }
}
export default adminSetUserPassword
